import { types } from 'mobx-state-tree'

export const StoreAreaModel = types.model('StoreAreaModel', {
  id: types.number,
  name: types.string,
  isDeletable: types.boolean,
})
